<template>
  <li class="header-ecosystem-item">
    <a :href="link" target="_blank" class="link">
      <div class="image-wrapper">
        <img :src="cropImage(image)" :alt="title" class="image" />
      </div>

      <div class="name">
        <p class="title">{{ title }}</p>
        <p class="description">{{ description }}</p>
      </div>
      <div class="icon-wrapper">
        <BaseIconSvoi icon="arrow/right-up" size="l" />
      </div>
    </a>
  </li>
</template>

<script setup lang="ts">
  import { BaseIconSvoi } from '~/components/base-ui/icon'
  import { useCropImage } from '~/composables/use-crop-image'

  defineProps({
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
  })

  const { cropImage } = useCropImage()
</script>

<style lang="scss" scoped>
  .header-ecosystem-item {
    width: 100%;

    > .link {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 16px;
      border-radius: 24px;
      background-color: transparent;
      color: $color-default-black;
      transition:
        background-color $trans-default,
        box-shadow $trans-default;

      @include vp-1439 {
        padding: 0;
      }

      @include hover {
        background-color: $color-default-white;
        box-shadow: 0 8px 32px rgb(0 0 0 / 10%);

        > .icon-wrapper {
          background-color: $color-kiwi-60;
        }

        @include vp-1439 {
          background: transparent;
          box-shadow: none;
        }
      }
    }

    > .link > .image-wrapper {
      width: 64px;
      height: 64px;
      border-radius: 20px;
      overflow: hidden;
      flex-shrink: 0;
      background: #f6f7f8;
    }

    > .link > .image-wrapper > .image {
      object-fit: cover;
    }

    > .link > .name {
      display: flex;
      width: 100%;
      flex-direction: column;
    }

    > .link > .name > .title {
      font-size: 16px;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 4px;
    }

    > .link > .name > .description {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      white-space: initial;
      color: $color-potato-50;
    }

    > .link > .icon-wrapper {
      width: 48px;
      height: 48px;
      background-color: $color-kiwi-50;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      flex-shrink: 0;

      @include hover {
        transition: background-color $trans-default;
      }
    }
  }
</style>
